import { Module } from 'vuex'

import { State as RootState } from '@/store/state'
import { Information, initState, mutations, getters } from './state'
import actions from './actions'

const module: Module<Information, RootState> = {
  namespaced: true,
  state: initState,
  mutations,
  getters,
  actions,
}

export default module
